(function () {
    'use strict';

    var module = angular.module('uwAgenda.tasks');

    /* controller for new/edit a task */
    module.controller('TaskDetailController', [
        '$scope',
        '$q',
        '$uibModalInstance',
        '$localStorage',
        '$translate',
        'ContactService',
        'TaskService',
        'UserService',
        'Alert',
        'CallsService',
        'TaskStateEnum',
        'SharedAgendaService',
        'AppointmentDetailService',
        'SearchService',
        'task',
        'FlagTypeEnum',
        function ($scope,
                  $q,
                  $uibModalInstance,
                  $localStorage,
                  $translate,
                  ContactService,
                  TaskService,
                  UserService,
                  Alert,
                  CallsService,
                  TaskStateEnum,
                  SharedAgendaService,
                  AppointmentDetailService,
                  SearchService,
                  task,
                  FlagTypeEnum) {
            /* jshint validthis:true */
            var vm = this;
            // current task
            vm.task = {};
            // task states
            vm.taskState = {};
            // current agenda
            vm.agenda = {};
            // list of possible contact-infos to add
            vm.contactInfos = [];

            vm.initialFirstName = '';
            vm.initialLastName = '';

            $scope.$watch('vm.task.isIntern', function(newVal, oldVal) {
                if(vm.task.isIntern)
                {
                    vm.task.isImportant = true;
                    vm.task.alertDateTime = null;
                    vm.task.sendNotification = false
                }
            });

            $scope.$watch('vm.task.sendNotification', function(newVal, oldVal) {
                if(vm.task.sendNotification)
                {
                    if (!vm.task.alertDateTime){
                        vm.task.alertDateTime = new Date();
                    }
                }else{
                    vm.task.alertDateTime = null;
                }
            });

            activate();

            vm.flagChanged = function(flagValue) {
                // if flag is set 
                // that task state must be "FollowUpByOperator" by default
                if (flagValue || flagValue === FlagTypeEnum.Move.value) {
                    vm.task.taskState = TaskStateEnum.FollowUpByOperator.value;
                }
            }

            /* quick search patients */
            vm.search = function (searchValue) {
                return SearchService.searchPatients(SharedAgendaService.data.currentAgenda.owner.id, searchValue);
            };

            // Create/Get Patient (If Available)
            function patient() {
                var deferred = $q.defer();

                // Do We Need To Create New Patient ?
                if (!vm.task.isToDo &&
                    vm.task.patientDto &&
                    vm.task.patientDto.lastName) {

                    // Create Patient Object To Save
                    var patientToSave = {
                        id: vm.task.patientDto.id,
                        firstName: vm.task.patientDto.firstName,
                        lastName: vm.task.patientDto.lastName,
                        eyeFileUserId: vm.task.patientDto.eyeFileUserId,
                        birthday: vm.task.patientDto.birthday && vm.task.patientDto.birthday === 'Invalid date' ? null : vm.task.patientDto.birthday,
                        fK_Language: vm.task.patientDto.languageId
                    };

                    // contact-infos
                    var i = 0;
                    if (vm.task.patientDto.contactInfos)
                    {
                        var len = vm.task.patientDto.contactInfos.length;
                        for (i = 0; i < len; i++) {
                            vm.task.patientDto.contactInfos[i].prepareForSave();
                        } // for
                        patientToSave.contactInfos = vm.task.patientDto.contactInfos;
                    }else{
                        Alert.warning("User has no contactinfo, so notifications will not be sent");
                    }

                    // Create New Patient Before
                    return UserService.quickSavePatient(SharedAgendaService.data.currentAgenda.id, patientToSave).then(function (patient) {

                        if ($localStorage.ExternalPatientIncomingData)
                        {
                            // refresh externalpatient with new created one
                            UserService.refreshExternalPatientSearchResult(patient);
                        }
                        return patient.id;
                    });
                } // if
                else {
                    // patient-id Or null
                    deferred.resolve(vm.task.patientDto ? vm.task.patientDto.id : null);

                    return deferred.promise;
                } // if
            } // patient


            /* save or update task */
            vm.save = function () {
                if (vm.moreThanOneEmail()) {
                    Alert.error('single_email_allowed');
                    return;
                }

                // check if we are updating a selected user or not and show popup
                if (vm.task.patientDto.id > 0 && (vm.task.patientDto.firstName.trim() !== vm.initialFirstName.trim() || vm.task.patientDto.lastName.trim() !== vm.initialLastName.trim())) {
                    // if userModifyingPopup returns true we continue, otherwise we cancel so user can check 
                    ContactService.showUserIsBeingModifiedPopUp(vm.initialFirstName.trim(), vm.initialLastName.trim(), vm.task.patientDto.firstName.trim(), vm.task.patientDto.lastName.trim())
                        .result
                        .then(function (okToSaveAppointment)
                        {
                            if (okToSaveAppointment)
                            {
                                patient().then(function (patientId) {
                                    vm.saveTask(vm.task, patientId);
                                });
                            }
                        });
                }else{
                    patient().then(function (patientId) {
                        vm.saveTask(vm.task, patientId);
                    });
                }
            };

            vm.saveTask = function (task, patientId)
            {
                let promises;
                // prepare for backend
                task.prepareForBackend();

                // set patient-id
                task.fK_Patient = patientId;

                // save or update 
                if (task.id && task.id > 0) {
                    // update
                    if (vm.selectedAgendas && vm.selectedAgendas.length > 0) {
                        promises = vm.selectedAgendas.map(function (agenda) {
                            return TaskService.updateTask(task.id, task, agenda.id);
                        });

                        $q.all(promises).then(function (results) {
                            // send result to caller of modal
                            $uibModalInstance.close(results);
                            Alert.success($translate.instant('note_updated'));
                        });
                    }
                } // if
                else {
                    if (vm.selectedAgendas && vm.selectedAgendas.length > 0) {
                        // save service
                        promises = vm.selectedAgendas.map(function (agenda) {
                            return TaskService.saveTask(task, agenda.id);
                        });

                        $q.all(promises).then(function (results) {
                            // send result to caller of modal
                            $uibModalInstance.close(results);
                            Alert.success($translate.instant('note_added'));
                        });
                    }
                } // else  
                // clear external loaded user in localstorage after creating task
                UserService.clearExternalPatient();

            };

            /* abort */
            vm.abort = function () {
                $uibModalInstance.dismiss('cancel');
            };

            function emailsInContactInfos() {
                let count = 0;
                for (let i = 0; i < vm.task.patientDto.contactInfos.length; i++) {
                    if (vm.task.patientDto.contactInfos[i].userContactInfoType &&
                        vm.task.patientDto.contactInfos[i].userContactInfoType.type === 3) {
                        count++;
                    }
                }
                return count;
            }

            vm.moreThanOneEmail = () => {
                return emailsInContactInfos() > 1;
            };

            /* activation work */
            function activate() {
                // set current task
                vm.task = task;

                // Agenda
                vm.agenda = SharedAgendaService.data.currentAgenda;

                if (vm.agenda.sendTaskNotificationByDefault)
                {
                    vm.task.sendNotification = true;
                }
                // task states
                vm.taskState = TaskStateEnum;

                // set default pinned-date for daytasks
                // if (!vm.task.isToDo && !vm.task.pinnedToDate) {
                //     vm.task.pinnedToDate = DateService.data.date;
                // }

                // Preparing for Create-New-Patient
                prepareForCreateNewPatient();

                if(!vm.task.patientDto.firstName && !vm.task.patientDto.lastName && SharedAgendaService.data.currentAgenda.allowPhoneNumberRecognition){
                    // preselect patient if incoming data from external system
                    UserService.preSelectExternalPatient(vm.task, SharedAgendaService.data.currentAgenda.owner.id, SharedAgendaService.data.currentAgenda.id);
                }

                // listen
                listen();


            } // activate

            // prepare Create-New-Patient
            // just create new patient as there is a watcher on this object to copy to patientdto
            function prepareForCreateNewPatient() {
                if (!vm.task.patientDto) {
                    vm.task.patientDto = {
                        contactInfos: []
                    };
                }
                vm.task.patientDto.contactInfos = AppointmentDetailService.generateNeededContactInfoTypes(vm.task.patientDto.contactInfos, vm.agenda.contactInfoTypesInAppointment);
                vm.task.patient = vm.task.patientDto;
            }


            // listen
            function listen() {
                // if a patient was searched -> display it in content of task
                var patientDtoWatcher = $scope.$watch(function () {
                    return vm.task.patientDto;
                }, function (newVal, oldVal) {

                    // prepare for new patient
                    prepareForCreateNewPatient();

                    // set initial first and last name to compare for updating user check
                    vm.initialFirstName = vm.task.patientDto.firstName;
                    vm.initialLastName = vm.task.patientDto.lastName;
                });

                // if a patient was searched -> display it in content of task
                var externalPatientWatcher = $scope.$watch(function () {
                    return vm.task.patient;
                }, function (newVal, oldVal) {
                    // otherwise, update the patientDto
                    vm.task.patientDto = vm.task.patient;
                    
                });

                // destroy
                $scope.$on("$destroy", function () {
                    patientDtoWatcher();
                    patientDtoWatcher = null;
                    externalPatientWatcher();
                    externalPatientWatcher = null;
                });
            } // listen


        }]);
})();